import FileMetaDTO from "@/dto/files/FileMetaDTO";

export default class CompaniesDTO {

    userId!: number;

    companies: Array<CompanyDTO> = []

}

export class CompanyDTO {

    public userId: number | null = null;

    id: number | null = null;

    name: string | null = null;

    ein: string | null = null;

    public companyType: string | null = null;

    public revenue: string | null = null;

    public state = "";

    public city = "";

    public address = "";

    public street = "";

    public zipCode = "";

    public irsLetter: FileMetaDTO | null = null;

    public incCertificate: FileMetaDTO | null = null;

    public filingReceipt: FileMetaDTO | null = null;

    public coFounders: Array<FounderDTO> = []

}

export class FounderDTO {

    public id: number | null = null;

    public firstName = "";

    public lastName = "";

    public ssn = "";

    public occupation = "";

    public state = "";

    public city = "";

    public address = "";

    public street = "";

    public zipCode = "";

    public usResident = true;

    public foreignAddress = "";

    public country = "";

    public share = 0.0;

    public usAddress = true;

}